
    /**
    * 校验 供应商姓名 是否重复
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqApiCheckSupplyName25787 {
  /**
   * (String)
   */
  companyName: string | number;
}
    /**
 * Response<OfficalCheckNameForSubmitResp> :Response
 */
export class IResApiCheckSupplyName25787 {
  message?: {};
  code?: {};
  /**
   * OfficalCheckNameForSubmitResp
   */
  data?: {
    /**
     * 0未入驻1已入驻
     */
    exist?: {};
  };
}
    const http: Serve<IReqApiCheckSupplyName25787, IResApiCheckSupplyName25787> = (data?) =>  request({
      method: 'GET',
      url: '/api/check/supplyName',
      params: data
    }) 
    export default http